export default __webpack_public_path__ + "static/media/Lubis-Tech.d16c6cff.png";